import React from 'react';

import { Badge, Text, useMantineTheme } from '@mantine/core';
import { IconClockHour4 } from '@tabler/icons-react';
import { useDemoGymExpiration } from 'hooks/useDemoGymExpiration';

const DemoGymExpirationBadge = ({ expiresAt }: { expiresAt: string }): React.ReactElement => {
  const theme = useMantineTheme();
  const { color, timeText } = useDemoGymExpiration(expiresAt);

  return (
    <Badge
      variant='light'
      color={color}
      sx={{ textTransform: 'lowercase' }}
      styles={{ inner: { display: 'flex', alignItems: 'center', gap: 4 } }}
    >
      <IconClockHour4 size={theme.fontSizes.sm} />
      <Text>{timeText}</Text>
    </Badge>
  );
};

export default DemoGymExpirationBadge;
